/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum EditorDocStatus {
    DRAFT = 'draft',
    REVIEW = 'review',
    COMPLETE = 'complete',
    ARCHIVE = 'archive',
    CONTEXT = 'context',
    FRAMING = 'framing',
    DRAFT_TRACKER = 'draft_tracker',
    REFRESH = 'refresh',
    RETROSPECTIVE = 'retrospective',
    EXECUTION = 'execution',
    PLANNING_COMPLETE = 'planning_complete',
}
